import { useMutation } from '@tanstack/react-query';
import { container } from '@src/container';
import { AuthService } from '@src/application/users/usecases';

/**
 * Hook: useSendOtp
 * Sends OTP to user's email for authentication
 * 
 * @example
 * const { mutate: sendOtp, isPending } = useSendOtp();
 * sendOtp({ email: 'user@example.com' });
 */
export function useSendOtp() {
    const authService = container.resolve<AuthService>('authService');

    return useMutation({
        mutationFn: async ({ email }: { email: string }) => {
            return await authService.sendOtp(email);
        },
        // Disable retries for OTP sending
        retry: false,
    });
}
